import {memo} from 'react';
import {PayrollFileRow} from '@api/lib/payrollProcessing/types';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@common-web/components/ui/table';

export const SampleDataTable = memo(
  ({
    sampleData,
    maxRows = 5,
    disableColumnSort,
  }: {
    sampleData: PayrollFileRow[];
    maxRows?: number;
    disableColumnSort?: boolean;
  }) => {
    const keys = Object.keys(sampleData[0] || {});
    if (!disableColumnSort) {
      keys.sort((a, b) => a.localeCompare(b));
    }

    return (
      <div className='w-full max-w-full overflow-x-auto'>
        <div className='border border-gray-200 rounded-lg max-w-full'>
          <Table className={'w-full whitespace-nowrap'}>
            <TableHeader>
              <TableRow className='bg-gray-50'>
                {keys.map((key) => (
                  <TableHead key={key} className='font-semibold min-w-32'>
                    {key}
                  </TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {sampleData.slice(0, maxRows).map((row, i) => {
                return (
                  <TableRow key={i} className='hover:bg-gray-50'>
                    {keys.map((k, j) => (
                      <TableCell key={j} className='max-w-48'>
                        <div className='truncate text-sm' title={String(row[k] || '')}>
                          {String(row[k] || '')}
                        </div>
                      </TableCell>
                    ))}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </div>
    );
  },
);
